import React from 'react';
import { number, bool } from 'prop-types';
import { Skeleton, SkeletonContent, SkeletonLine, SkeletonBlock } from '@one-thd/sui-atomic-components';

export const ListViewPlaceHolder = ({ count, isMobile }) => {
  const placeholders = new Array(Math.max(1, count)).fill('');
  return (
    <>
      {placeholders.map((placeholder, placeholderIndex) => {
        return (
          <div key={placeholderIndex} data-testid="list-item-placeholder" className="sui-py-1 sui-w-full">
            {
              isMobile && (
                <Skeleton
                  disablePadding="x"
                  orientation="horizontal"
                  PaperProps={{
                    className: 'sui-w-full sui-border-b-1 sui-border-solid sui-border-primary',
                    variant: 'shadow'
                  }}
                >
                  <div className="sui-grid sui-grid-cols-2">
                    <SkeletonContent disablePadding={false} initialSize="2/4">
                      <SkeletonBlock aspect="wide" />
                    </SkeletonContent>
                    <SkeletonContent disablePadding="y" initialSize="2/4">
                      <SkeletonLine numberOfLines={5} />
                    </SkeletonContent>
                  </div>
                  <SkeletonContent disablePadding="x">
                    <SkeletonLine numberOfLines={2} />
                  </SkeletonContent>
                </Skeleton>
              )
            }
            {
              !isMobile && (
                <Skeleton
                  orientation="horizontal"
                  PaperProps={{
                    className: 'sui-w-full sui-border-b-1 sui-border-solid sui-border-primary',
                    variant: 'shadow'
                  }}
                >
                  <SkeletonContent initialSize="1/4">
                    <SkeletonBlock aspect="wide" />
                  </SkeletonContent>
                  <SkeletonContent initialSize="2/4">
                    <SkeletonLine numberOfLines={4} />
                  </SkeletonContent>
                  <SkeletonContent initialSize="1/4">
                    <SkeletonLine numberOfLines={4} />
                  </SkeletonContent>
                </Skeleton>
              )
            }
          </div>
        );
      })}
    </>
  );
};

ListViewPlaceHolder.displayName = 'ListViewPlaceHolder';

ListViewPlaceHolder.propTypes = {
  count: number,
  isMobile: bool
};

ListViewPlaceHolder.defaultProps = {
  count: 24,
  isMobile: false
};
